/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkReportScheduleRequest {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkReportScheduleRequest.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkReportScheduleRequest>): WellArchitectedFrameworkReportScheduleRequest {
        let obj = Object.assign(new WellArchitectedFrameworkReportScheduleRequest(), model);
        WellArchitectedFrameworkReportScheduleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkReportScheduleRequest>): WellArchitectedFrameworkReportScheduleRequest {
        if (!model) return null;
        return WellArchitectedFrameworkReportScheduleRequest.newInstance(<WellArchitectedFrameworkReportScheduleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkReportScheduleRequest) {
        if (!obj) return;

        models.WellArchitectedFrameworkReportScheduleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkReportScheduleRequest): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkReportScheduleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_id) {
            models.RecordIdentity.fixupPrototype(this.assessment_id);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * The Assessment this report is for
     */
    assessment_id: models.RecordIdentity;

    /**
     * Identity of the Framework
     */
    framework_id: string;

    /**
     * Report type for assessment run
     */
    report_type: models.WellArchitectedFrameworkAssessmentRunReportType;

    /**
     * User ID of user who scheduled the report
     */
    user_id: string;

    /**
     * Schedule ID of which the report to be generated
     */
    schedule_id: string;

    email_recipients: Array<string>;

    filters: models.QueryOperator;

}
